<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12 sm6 child-flex>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
              <h3 style="text-align:left;margin-bottom: 10px">CSV Bulk Upload</h3>
              <v-btn flat class="primary" style="margin-left:350px;margin-bottom: 10px;margin-top:-10px" v-on:click="back()">Back</v-btn>
              </v-layout>
              <v-divider divider: true style="margin-bottom: 50px"></v-divider>
              <p style="text-align:left,margin-top: 50px">Upload new list as</p>
              <p style="text-align:left,margin-top: 20px">Freight Forwarding / Inland Logistics / Custom Clearance</p>
              <v-btn align-center style="margin-top: 20px;background-color: white;padding-top: 20px;padding-bottom: 40px">
                <v-icon color="primary" style="margin-right: 10px">backup</v-icon>
                    Click or Drop Files Here To Upload
              </v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex d-flex xs12 sm6>
          <v-card style="margin-left:20px">
            <v-card-text>
              <h3 style="text-align:left;margin-bottom: 10px">CSV Sample Download</h3>
              <v-divider divider: true></v-divider>
              <v-btn align-left flat style="margin-top: 20px;background-color: white;padding-top: 20px;padding-bottom: 40px;width:410px">
                <v-icon color="primary" style="margin-right: 10px">file_download</v-icon>
                    Download Freight forwarding Template
              </v-btn>
              <v-btn align-left flat style="margin-top: 20px;background-color: white;padding-top: 20px;padding-bottom: 40px;width:410px">
                <v-icon color="primary" style="margin-right: 10px">file_download</v-icon>
                    Download Custom Clearance Template
              </v-btn>
              <v-btn align-left flat style="margin-top: 20px;background-color: white;padding-top: 20px;padding-bottom: 40px;width:410px">
                <v-icon color="primary" style="margin-right: 10px">file_download</v-icon>
                    Download Inland Logistics Template
              </v-btn>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex d-flex xs12>
          <v-layout column>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                      <v-card-text>
                        <h3 style="text-align: left;margin-bottom: 10px">Progress Bar</h3>
                        <v-divider divider: true></v-divider>
                        <v-layout>
                          <v-flex xs8 child-flex>
                            <v-progress-linear
                              slot="progress"
                              :value="10"
                              :color= "blue"
                              height="7"
                              style="margin-top:70px;margin-left:10px;margin-right: 10px"
                              align-center
                            ></v-progress-linear>
                          </v-flex>
                          <v-flex xs4 child-flex>
                            <p style="text-align: center;margin-top: 20px">Download Error Log File</p>
                            <v-btn align-center flat style="margin-top: 20px;background-color: white;padding-top: 20px;padding-bottom: 40px;">
                              <v-icon color="primary" style="margin-right: 10px">cloud_download</v-icon>
                                  Download CSV
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
            </v-flex>
            <v-flex d-flex>
              <v-card style="margin-top:20px">
                <v-card-text>
                  <h3 style="text-align: left;margin-bottom: 10px">Upload File Progress Report Table</h3>
                  <v-divider divider: true></v-divider>
                  <v-layout row wrap>
                    <v-flex xs3 child-flex>
                      <v-layout row wrap>
                        <label style="margin-top:20px;margin-right: 10px">Show</label>
                        <v-overflow-btn
                          :items="dropdown_list"
                          label=""
                          target="#dropdown-example"
                        ></v-overflow-btn>
                        <label style="margin-top:20px;margin-left: 10px">Entries</label>
                      </v-layout>
                    </v-flex>
                    <v-flex xs3 child-flex></v-flex>
                    <v-flex xs6 child-flex>
                      <v-layout row wrap>
                        <v-text-field
                          label="Search"
                        ></v-text-field>
                        <v-btn class="primary" flat style="margin-top:10px;"><v-icon dark>search</v-icon></v-btn>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.no}}</td>
                      <td class="text-xs-left">{{ props.item.calories }}</td>
                      <td class="text-xs-left">{{ props.item.fat }}</td>
                      <td class="text-xs-left">{{ props.item.carbs }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      dropdown_list: [1, 2, 3, 4, 5],
      headers: [
        {
          text: '#',
          align: 'left',
          value: 'no'
        },
        { text: 'Sales Order No', value: 'calories' },
        { text: 'Booking No', value: 'fat' },
        { text: 'Status', value: 'carbs' }
      ],
      desserts: [
        {
          no: '1',
          calories: '9890253698',
          fat: 'AME/FF/17081001',
          carbs: 'Successfully Created'
        },
        {
          no: '2',
          calories: '9863251487',
          fat: 'AME/FF/17081002',
          carbs: 'Successfully Created'
        },
        {
          no: '3',
          calories: '9865214789',
          fat: 'AME/FF/17081003',
          carbs: 'Successfully Created'
        }
      ]
    }
  },
  mounted () {
    console.log('bulkbooking page')
  },
  methods: {
    back () {
      this.$router.push('/Dashboard')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>



// WEBPACK FOOTER //
// src/components/Bulkbooking.vue